import React from 'react'
import { ProviderRoleId } from '../../currentRole'
import CarePlanBody from './CarePlanBody'

type Props = { role: ProviderRoleId }

const PlanViewer = ({ role }: Props) => <CarePlanBody role={role} readOnly />

export default PlanViewer
